export function getDataLayer(id, lead_id) {
  return { id, lead_id }
}
